import { Language } from '../constants/language';
import { Agent } from './agent';
import { OperatingMode } from './auth';
import { MemberSession } from './member';

export class Session {
	isLoggedIn: boolean;
	isAgent: boolean;
	isMember: boolean;
	isAdmin: boolean;
	isFirstResponder: boolean;
	isVersionIncompatible: boolean;
	operatingMode: OperatingMode;
	agent: Agent;
	member: MemberSession;
	locationName: string;
	erLocationID: string;
	selectedBrokerId: number;
	language: Language;
	isDarkMode: boolean;
	isFirstLoad: boolean;
	firstResponderComCode: string;
	isFaqActive: boolean;
	loginImage: string;
	firstResponderLoginImage: string;
	adminUserName: string;
	useYearRound: boolean;


	constructor() {
		this.isLoggedIn = false;
		this.isAgent = false;
		this.isMember = false;
		this.isAdmin = false;
		this.isFirstResponder = false;
		this.isVersionIncompatible = false;
		this.operatingMode = new OperatingMode;
		this.member = null;
		this.locationName = null;
		this.erLocationID = null;
		this.selectedBrokerId = 0;
		this.language = Language.en;
		this.isDarkMode = false;
		this.isFirstLoad = true;
		this.firstResponderComCode = null;
		this.isFaqActive = false;
		this.loginImage = null;
		this.firstResponderLoginImage = null;
		this.adminUserName = '';
		this.useYearRound = false;
	}
}